import { useEffect, useState } from "react";
import { apiTv, type TvDados } from "../lib/api";
import { Logo } from "../components/Logo";
import { n } from "../lib/format";
import { useOrdenacao, ThOrdena } from "../hooks/useOrdenacao";

// painel_producao_tv — TV da fábrica (abre em /#tv, sem login). Contadores + as 17 primeiras PCFs
// abertas da fila com o tempo restante da etapa atual e a cor do andamento (legenda do legado).
const CORES: Record<string, React.CSSProperties> = {
  branco: { background: "#fff", color: "#000" },
  verde: { background: "rgb(69,201,138)", color: "#000" },
  amarelo: { background: "rgb(236,208,13)", color: "#000" },
  vermelho: { background: "rgb(230,77,77)", color: "#000" },
  preto: { background: "#000", color: "#fff" },
};

export function PainelTv() {
  const [d, setD] = useState<TvDados | null>(null);
  const [erro, setErro] = useState<string | null>(null);
  const ord = useOrdenacao(d?.linhas, {
    ord: (l) => l.ordem, pcf: (l) => l.numpcf, eta: (l) => l.etapa, sit: (l) => l.situac, rest: (l) => l.restante,
  });

  useEffect(() => {
    const ler = () =>
      apiTv
        .dados()
        .then((x) => {
          setD(x);
          setErro(null);
        })
        .catch((e) => setErro((e as Error).message));
    void ler();
    const t = window.setInterval(ler, 30000); // CmTimer1: redesenha periodicamente
    return () => window.clearInterval(t);
  }, []);

  const card = (rot: string, v: number, destaque = false) => (
    <div className={"tv-card" + (destaque ? " tv-card-atr" : "")}>
      <span>{rot}</span>
      <b>{n(v)}</b>
    </div>
  );

  return (
    <div className="tv">
      <header className="tv-topo">
        <Logo />
        <h1>Posição da Fábrica</h1>
      </header>
      {erro && <div className="status-error">{erro}</div>}
      {d && (
        <>
          <div className="tv-cards">
            {card("Pedidos", d.pedidos)}
            {card("Não programadas", d.naoProgramadas)}
            {card("Não iniciadas", d.naoIniciadas)}
            {card("Paradas", d.paradas)}
            {card("Atrasadas", d.atrasadas, true)}
          </div>
          <table className="tv-tabela">
            <thead>
              <tr>
                <ThOrdena ord={ord} col="ord">#</ThOrdena>
                <ThOrdena ord={ord} col="pcf">PCF</ThOrdena>
                <ThOrdena ord={ord} col="eta">Etapa Atual</ThOrdena>
                <ThOrdena ord={ord} col="sit">Situação</ThOrdena>
                <ThOrdena ord={ord} col="rest">Tempo restante (min)</ThOrdena>
              </tr>
            </thead>
            <tbody>
              {ord.linhas.map((l) => (
                <tr key={l.numpcf} style={CORES[l.cor]}>
                  <td>{l.ordem}</td>
                  <td>{l.numpcf}</td>
                  <td>{l.etapa}</td>
                  <td>{l.situac}</td>
                  <td>{l.restante}</td>
                </tr>
              ))}
            </tbody>
          </table>
          <div className="tv-legenda">
            <span style={CORES.verde}>até 50% do tempo</span>
            <span style={CORES.amarelo}>51% a 75%</span>
            <span style={CORES.vermelho}>76% a 100%</span>
            <span style={CORES.preto}>tempo estourado</span>
          </div>
        </>
      )}
    </div>
  );
}
